<template>
  <!-- Home Section start-->
  <section id="home" class="home">
    <div class="container-fluid px-0">
      <div class="row">
        <div class="col-sm-12">
          <video
            autoplay
            muted
            loop
            playsinline
            poster="../assets/images/slide2.jpg"
            class="w-100"
            style="pointer-events: none;"
          >
            <source
              src="../assets/videos/animation-slider-clean-touch-protect.mp4"
              type="video/mp4"
            />
            Votre navigateur ne permet pas de lire les vidéos. Mais vous pouvez
            toujours
            <a href="../assets/videos/animation-slider-clean-touch-protect.mp4"
              >la télécharger</a
            >
            !
          </video>
          <div
            class="d-md-block"
            style="position: absolute; top: 0; bottom: 0; left: 0; right: 0"
          >
            <div class="row h-100 align-items-center">
              <div
                class="col-md-10 my-h-100   d-flex flex-column justify-content-center col-xl-4 offset-md-1 text-left my-bg px-5 p-md-4 p-lg-5 text-center"
              >
                <h1 class="my-title text-md-left my-title-full">
                  Film de protection anti-coronavirus
                </h1>
                <p
                  class="d-none d-md-block text-light lead text-left my-p mb-3"
                >
                  Ce film adhésif antimicrobien qui agit contre les coronavirus,
                  dont le SARS-COV-2 (COVID19), est une barrière sanitaire
                  efficace qui sécurise, protège et assainit votre
                  environnement. <br />
                </p>
                <div class="mt-md-3" style="position:relative">
                  <a
                    style="display:inline-block"
                    href="static/ctp.pdf"
                    class="my-slider-button my-no-hover"
                    download
                  >
                    Découvrir notre produit</a
                  >
                </div>
              </div>
              <div class="d-none d-xl-block col-xl-4 offset-3">
                <img class="img-fluid" src="../assets/images/pure-zone.png" />
              </div>
            </div>
          </div>
          <!-- <swiper class="swiper my-swiper" ref="homeSwiper" :options="homeOptions">
            <swiper-slide class="text-center">
              <img
                class="img-fluid"
                style="width: 100%"
                src="../assets/images/slide1.jpg"
                alt="slide"
              />
               <div
                class="d-none d-md-block"
                style="position: absolute; top: 0; bottom: 0; left: 0; right: 0"
              >
                <div class="h-100">
                  <div class="row h-100 align-items-center">
                    <div class="col-md-10 col-xl-4 offset-1 text-left  my-bg p-3">
                      <h1 class="my-title text-left">
                        Film de protection <br> anti-coronavirus
                      </h1>
                      <p class="text-light lead text-left my-p">
                        Ce film adhésif antimicrobien efficace contre les coronavirus est une barrière sanitaire efficace qui sécurise, protège et assainit votre environnement.
                      </p>
                      <!--   <div class="home-tile" style="background-color: rgba(255, 255, 255, .7)">
                                            <h1 style="color:#004D9D">Clean touch <span class="f-bold f-color">Protect</span></h1>
                                            <p style="font-size: 18px">Film adhésif anti microbien et Anti-coronavirus PURE ZONE<br/>Efficace à 99,9% contre la covid-19</p>
                                        </div> !--><!-- 
                                         <button class="my-slider-button mt-3" >
                       <a href="./../clean-touch-protect/static/ctp.pdf"  class="my-no-hover"> Découvrir notre produit</a>
                      </button>
                    </div>
                    <div class="d-none d-xl-block col-xl-4 offset-3">
                        <img class="img-fluid" src="../assets/images/pure-zone.png">
                        </div>
                  <!--  <div class="col-md-12">
                      <button class="my-slider-button" >
                       <a href="#about"  class="my-no-hover"> Découvrir notre Produit</a>
                      </button>
                      <button class="my-slider-button">
                        <a href="./../clean-touch-protect/static/ctp.pdf"  class="my-no-hover">Télécharger notre plaquette</a>
                      </button> 
                    </div> !--><!-- 
                  </div>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="text-center">
              <img
                class="img-fluid"
                style="width: 100%"
                src="../assets/images/slide2.jpg"
                alt="slide"
              />
              <div
                class="d-none d-md-block "
                style="position: absolute; top: 0; bottom: 0; left: 0; right: 0"
              >
                <div class="h-100">
                  <div class="row h-100 align-items-center">
                    <div class="col-md-10 col-xl-4 offset-1 text-left my-bg p-3">
                      <h1 class="my-title text-left">
                        Film de protection <br> anti-coronavirus
                      </h1>
                      <p class="text-light lead text-left my-p">
                        Ce film adhésif antimicrobien efficace contre les coronavirus est une barrière sanitaire efficace qui sécurise, protège et assainit votre environnement.
                      </p>
                      <!--   <div class="home-tile" style="background-color: rgba(255, 255, 255, .7)">
                                            <h1 style="color:#004D9D">Clean touch <span class="f-bold f-color">Protect</span></h1>
                                            <p style="font-size: 18px">Film adhésif anti microbien et Anti-coronavirus PURE ZONE<br/>Efficace à 99,9% contre la covid-19</p>
                                        </div> !--><!-- 
                                          <button class="my-slider-button mt-3" >
                       <a href="./../clean-touch-protect/static/ctp.pdf"  class="my-no-hover"> Découvrir notre produit</a>
                      </button>
                    </div>
                     <div  class="d-none d-xl-block col-xl-4 offset-3">
                        <img class="img-fluid" src="../assets/images/pure-zone.png">
                        </div>
                  </div>
                </div>
              </div>
            </swiper-slide>

            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper> -->
        </div>
      </div>
    </div>
  </section>
  <!--Home Section End -->
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      /* homeOptions: {
        effect: "fade",
        slidesPerView: 1,
        speed:600,
        loop: true,
        lazy: true,
        autoplay: {
          delay: 4500,
          disableOnInteraction: false,
        },
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          dynamicBullets: true,
          clickable: true,
        },
      }, */
    };
  } /*
  computed: {
    swiper() {
      return this.$refs.homeSwiper.$swiper;
    },
  }, */
};
</script>



// WEBPACK FOOTER //
// src/components/home.vue